module.exports = __webpack_public_path__ + "static/media/CircularStd-BlackItalic.2153a12d.woff";